import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CurrencyPipe } from './currency/currency.pipe';
import { CurrencySignusColorPipe } from './currency/currency-signus-color.pipe';
import { CurrencySignusPipe } from './currency/currency-signus.pipe';
import { CurrencyColorPipe } from './currency/currency-color.pipe';
import { CurrencyDataPipe } from './currency/currency-data.pipe';

import { IntegerSignusColorPipe } from './numeric/integer-signus-color.pipe';
import { IntegerColorPipe } from './numeric/integer-color.pipe';
import { IntegerPipe } from './numeric/integer.pipe';
import { IntegerSignusPipe } from './numeric/integer-signus.pipe';
import { DoubleSignusColorPipe } from './numeric/double-signus-color.pipe';
import { DoubleColorPipe } from './numeric/double-color.pipe';
import { DoublePipe } from './numeric/double.pipe';
import { DoubleSignusPipe } from './numeric/double-signus.pipe';

import { PositiveNegativeBlueRedParenthPipe } from './positiveNegative/positive-negative-blue-red-parenth.pipe';
import { PositiveNegativeGreenRedParenthPipe } from './positiveNegative/positive-negative-green-red-parenth.pipe';
import { PositiveNegativeGreenRedPipe } from './positiveNegative/positive-negative-green-red.pipe';
import { PositiveNegativePipe } from './positiveNegative/positive-negative.pipe';

import { PercentSignusPipe } from './percent/percent-signus.pipe';
import { PercentSignusColorPipe } from './percent/percent-signus-color.pipe';
import { PercentColorPipe } from './percent/percent-color.pipe';
import { PercentPipe } from './percent/percent.pipe';
import { PercentBlueRedPipe } from './percent/percent-color-blue-red-parenth.pipe';
import { PercentColorParenthesesPipe } from './percent/percent-color-parentheses.pipe';

import { DashEmptyPipe } from './others/dash-empty.pipe';
import { LongOutGreenRedPipe } from './others/long-out-green-red.pipe';
import { SafeHtmlPipe } from './others/safeHtml.pipe';
import { UrlifyPipe } from './others/urlify.pipe';
import { SafeResourceUrlPipe } from './others/safeResourceUrl.pipe';
import { DxFormatNumberBox } from './others/dxFormatNumberBox.pipe';
import { PercentSignusColorParenthPipe } from './percent/percent-signus-color-parenth.pipe';

const declarations = [
  // currency
  CurrencyPipe,
  CurrencyColorPipe,
  CurrencySignusColorPipe,
  CurrencySignusPipe,
  CurrencyDataPipe,

  // numeric
  DoublePipe,
  DoubleColorPipe,
  DoubleSignusPipe,
  DoubleSignusColorPipe,
  IntegerPipe,
  IntegerColorPipe,
  IntegerSignusColorPipe,
  IntegerSignusPipe,

  // other
  DashEmptyPipe,
  LongOutGreenRedPipe,
  SafeHtmlPipe,
  SafeResourceUrlPipe,
  UrlifyPipe,
  DxFormatNumberBox,

  // percent
  PercentBlueRedPipe,
  PercentColorPipe,
  PercentSignusColorPipe,
  PercentSignusPipe,
  PercentPipe,
  PercentColorParenthesesPipe,
  PercentSignusColorParenthPipe,

  // poristive - negative
  PositiveNegativeBlueRedParenthPipe,
  PositiveNegativeGreenRedParenthPipe,
  PositiveNegativeGreenRedPipe,
  PositiveNegativePipe,
];

@NgModule({
  declarations: [...declarations],
  imports: [CommonModule],
  exports: [...declarations],
})
export class PipesModule {}
